export default __webpack_public_path__ + "static/media/audio_icon.077e0513.png";